// extracted by mini-css-extract-plugin
module.exports = {"price":"DisplayOfferPrice_price__HDoav","currency":"DisplayOfferPrice_currency__48NJw"};